import React from 'react';
import { createIcon } from './create-icon';
import './icon-ellipsis.scss';

export const IconEllipsis = createIcon(<div className="icon-ellipsis" />);
